(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    

  class StickyHeader extends HTMLElement {

    connectedCallback() {

      this.headerSection =
        document.querySelector('.section-header');

      this.updateHeaderHeight =
        this.updateHeaderHeight.bind(this);

      this.updateHeaderHeight();

      if (window.ResizeObserver && this.headerSection) {

        this.resizeObserver =
          new ResizeObserver(() => {
            this.updateHeaderHeight();
          });

        this.resizeObserver.observe(this.headerSection);
      }

      window.addEventListener(
        'resize',
        this.updateHeaderHeight,
        { passive: true }
      );
    }

    updateHeaderHeight() {

      if (!this.headerSection) {
        return;
      }

      const height =
        this.headerSection.offsetHeight;

      document.documentElement.style.setProperty(
        '--header-height',
        `${height}px`
      );
    }

    disconnectedCallback() {

      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
      }

      window.removeEventListener(
        'resize',
        this.updateHeaderHeight
      );
    }
  }

  if (!customElements.get('sticky-header')) {

    customElements.define(
      'sticky-header',
      StickyHeader
    );

  }



  class RsAnnouncementBar extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('.rs-announcement-slide'));
      this.currentIndex = this.slides.findIndex((slide) => slide.classList.contains('is-active'));

      if (this.slides.length < 2) return;

      const interval = Number(this.dataset.interval) || 4000;
      this.rotationTimer = window.setInterval(() => {
        this.currentIndex = (this.currentIndex + 1) % this.slides.length;
        this.slides.forEach((slide, index) => {
          const isActive = index === this.currentIndex;
          slide.classList.toggle('is-active', isActive);
          slide.setAttribute('aria-hidden', String(!isActive));
        });
      }, interval);
    }

    disconnectedCallback() {
      if (this.rotationTimer) window.clearInterval(this.rotationTimer);
    }
  }

  if (!customElements.get('rs-announcement-bar')) {
    customElements.define('rs-announcement-bar', RsAnnouncementBar);
  }

  /* Le voci provengono esclusivamente dal menu Shopify esistente. */
  function initRsMobileMenuAccordion(drawer) {
    if (!drawer || drawer.dataset.rsAccordionReady === 'true') return;
    const panel = drawer.querySelector('.menu-drawer');
    if (!panel) return;
    drawer.dataset.rsAccordionReady = 'true';

    const wrapper = drawer.closest('.rs-header__drawer');
    const topbar = document.createElement('div');
    topbar.className = 'rs-mobile-drawer__top';

    const brand = document.createElement('a');
    brand.className = 'rs-mobile-drawer__brand';
    brand.href = (wrapper && wrapper.dataset.rsHome) || '/';
    brand.textContent = (wrapper && wrapper.dataset.rsBrand) || 'RadianceSkin';

    const close = document.createElement('button');
    close.type = 'button';
    close.className = 'rs-mobile-drawer__close';
    close.setAttribute('aria-label', 'Chiudi il menu');
    close.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><path d="M5 5l14 14M19 5L5 19"/></svg>';
    close.addEventListener('click', () => {
      const toggle = drawer.querySelector('.menu-drawer-container > summary');
      if (toggle) toggle.click();
    });

    topbar.append(brand, close);
    panel.prepend(topbar);

    const normalize = (text) => String(text || '').replace(/\s+/g, ' ').trim().toLowerCase();

    drawer.addEventListener('click', (event) => {
      if (!window.matchMedia('(max-width: 989px)').matches) return;

      const summary = event.target.closest('summary.menu-drawer__menu-item');
      if (!summary || !panel.contains(summary)) return;
      const details = summary.parentElement;
      if (!details || !details.matches('details')) return;
      const submenu = Array.from(details.children).find(el => el.classList.contains('menu-drawer__submenu'));
      if (!submenu) return;

      event.preventDefault();
      event.stopPropagation();

      const isTopLevel = details.parentElement.matches('li') &&
        details.parentElement.parentElement === drawer.querySelector('.menu-drawer__navigation > .menu-drawer__menu');

      /* Conserva il comportamento preesistente: testo Catalogo / Prodotti /
         Strumenti naviga verso la pagina, chevron apre le sottocategorie. */
      if (isTopLevel) {
        const title = normalize(summary.textContent);
        const rect = summary.getBoundingClientRect();
        const onChevron = event.detail === 0 || event.clientX >= rect.right - 56;
        const parentUrl = window.rsMenuUrls && window.rsMenuUrls[title];
        if (!onChevron && parentUrl && /catalogo|prodotti|strumenti/i.test(title)) {
          window.location.assign(parentUrl);
          return;
        }

        const duplicateTitle = normalize(summary.textContent);
        submenu.querySelectorAll('.menu-drawer__menu > li').forEach(item => {
          const itemLabel = item.querySelector(':scope > a, :scope > details > summary');
          if (itemLabel && normalize(itemLabel.textContent) === duplicateTitle) {
            item.style.display = 'none';
            item.setAttribute('aria-hidden', 'true');
          }
        });
      }

      const opening = !details.open;
      details.open = opening;
      details.classList.toggle('menu-opening', opening);
      summary.setAttribute('aria-expanded', String(opening));
    }, true);
  }

  function setupRsMobileDrawers() {
    document.querySelectorAll('.rs-header__drawer header-drawer').forEach(initRsMobileMenuAccordion);
  }

  setupRsMobileDrawers();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupRsMobileDrawers, { once: true });
  }
  document.addEventListener('shopify:section:load', setupRsMobileDrawers);


  } catch(e) { console.error(e); }
})();
})();
